import type { StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { renderStructuredContent } from '../../rendererContext';
import type { RendererProps } from '../../types';
import { SpacingToken } from './types';

export type ContainerProps = StructuredContentDocument<{
  spacing?: {
    top?: SpacingToken;
    bottom?: SpacingToken;
  };
  rendererProps?: RendererProps;
}>;

const spacingMap: Record<SpacingToken, string | undefined> = {
  '0': '0',
  '1': '0.25rem',
  '2': '0.5rem',
  '3': '1rem',
  '3-half': '1.5rem',
  '4': '1.75rem',
  '5': '2.75rem',
};

export function Container({ props: { spacing, children, rendererProps } }: ContainerProps) {
  const spacingTop = spacingMap[spacing?.top ?? 0];
  const spacingBottom = spacingMap[spacing?.bottom ?? 0];
  return (
    <div
      style={
        {
          marginTop: spacingTop,
          marginBottom: spacingBottom,
        } as React.CSSProperties
      }
    >
      {renderStructuredContent(children, rendererProps)}
    </div>
  );
}
